import React, { ChangeEvent, useCallback, useMemo, useState } from "react";
import { onDeposit } from "../utils/contract-utils";

export interface Props {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function DepositModal({ showModal, setShowModal }: Props) {
  const [matic, setMatic] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDeposit = useCallback(async () => {
    try {
      setIsLoading(true);
      await onDeposit(matic);
      alert("Transaction susses");
      window.location.reload();
    } catch (error) {
      alert("Transaction false");
      console.log("error", error);
    }
    setIsLoading(false);
  }, [matic]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setMatic(e.target.value);
  };

  const renderButton = useMemo(() => {
    if (isLoading) {
      return (
        <div className="flex flex-col justify-center items-center pb-4">
          <div
            className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          >
            <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
              Loading...
            </span>
          </div>
        </div>
      );
    }

    return (
      <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
        <button
          className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          type="button"
          onClick={() => setShowModal(false)}
        >
          Close
        </button>
        <button
          className="rounded-full bg-gradient-to-r from-[#FD7155] to-[#6B94BC] px-5 py-1 text-lg text-white"
          type="button"
          onClick={handleDeposit}
        >
          Deposit
        </button>
      </div>
    );
  }, [handleDeposit, isLoading, setShowModal]);

  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-slate-100/40">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-3xl font-semibold">MATIC Deposit</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-6 flex justify-center items-center gap-2">
                  <input
                    value={matic}
                    onChange={handleInputChange}
                    className="bg-slate-100 h-10 px-3 rounded-md disabled:opacity-75"
                  />
                  <p className="text-lg font-semibold">MATIC</p>
                </div>
                {renderButton}
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
